import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import { IncludeEmbedHandler } from './include-embed-handler';
import EmbedComponent from "./embed-component.vue"
import * as SerializationApi from '@/app/state-serialization/api'
import { EmbedStateProtobufSerializer } from './embed-state-protobuf-serializer'

export const embedFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
  .toConstantValue(EmbedComponent)
  .whenTargetNamed("embed")

  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeEmbedHandler)

  bind(SerializationApi.StateSerializationPluginSymbol).to(EmbedStateProtobufSerializer)
})
